:host {
  display: block;
  height: 100%;
}

.sis-sidebar {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
}

.sidebar-header {
  padding: 24px 16px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
}

.logo {
  display: flex;
  align-items: center;
}

.trumpf-text {
  font-weight: bold;
  font-size: 20px;
  color: #000;
  margin-right: 8px;
}

.trumpf-square {
  width: 50px;
  height: 50px;
  background-color: #0051a2;
}

.new-chat-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-content {
  flex: 1;
  overflow-y: hidden;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
  font-size: 14px;
}

.sidebar-items {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.sidebar-item {
  padding: 15px;
  border-bottom: 1px solid #e6e6e6;
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    background-color: #f5f5f5;
  }

  &:focus {
    outline: none;
    background-color: #f0f0f0;
  }

  &.active {
    background: linear-gradient(270deg, #FFF 0%, #EFF0F4 38.3%, #EFF0F4 100%);
  }

  .title {
    margin-bottom: 3px;
    font-weight: 400;
  }

  .meta-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .subtitle {
    font-size: 11px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    margin-right: 8px;
  }

  .date {
    font-size: 12px;
    color: #999;
    text-align: right;
    white-space: nowrap;
  }
}
